/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import axios from 'axios'
import { getCookie } from '../util'
import { apiIDBCache } from '../../services/apiIDBCache'

axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
const isLoginPage = document.getElementById('txtInputName');
if(!isLoginPage){
  axios.defaults.headers.common['kxToken'] = getCookie('kxEntrySummaryToken') || getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN)
}
axios.defaults.method = 'post'

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return null;
}

function applyEditTransactionHeader() {
  const transactionId = getQueryVariable('shipmentHttpId') || getQueryVariable('transactionId');
  if (transactionId && String(transactionId).startsWith('KX-')) {
    axios.defaults.headers.common['editShipment'] = 'true';
  } else {
    delete axios.defaults.headers.common['editShipment'];
  }
}

applyEditTransactionHeader();

const custom = async (config = {}) => {
  applyEditTransactionHeader();
  let queryParamsString = "&"
  Object.keys(config.queryParams || {}).map(param => {
    queryParamsString = queryParamsString + param + "=" + config.queryParams[param] + "&"
  })
  config.url=config.url || axios.defaults.baseURL+ "?axd="+config.data.eventType + queryParamsString;
  return apiIDBCache.wrapAxiosRequest(config, (cfg) => axios(cfg));
}

const post = data => {
  let config = {}
  config.data = data
  config.url=config.url || axios.defaults.baseURL+ "?axd="+config.data.eventType;
  return axios(config)
}

const get = (url = '', data = '', config = {}) => {
  config.params = data
  config.method = 'get'
  return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del
}

export { HttpClient }
